import * as React from 'react';
import './TumourGroupPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ITumourGroupReduxFormState, initialTumourGroupState } from "../../../reducers/reactReduxForms/tumourGroup";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as TumourGroupActions from '../../../actions/tumourGroups';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { TrialLookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface ITumourGroupPageParams {
    tumourGroupId: number;
}

interface ITumourGroupPageProps {

    form: Dtos.TumourGroup & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITumourGroupReduxFormState;

    location: Location;
    tumourGroupId: number;
    match: match<ITumourGroupPageParams>;
    history: History;

    // From state
    tumourGroup: Dtos.TumourGroup;
    lookups: Dtos.Lookup[];

    loadingTumourGroup: boolean;
    loadTumourGroupSuccess: boolean;
    loadTumourGroupFailure: boolean;

    savingTumourGroup: boolean;
    saveTumourGroupSuccess: boolean;
    saveTumourGroupFailure: boolean;

    creatingTumourGroup: boolean;
    createTumourGroupSuccess: boolean;
    createTumourGroupFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITumourGroupPageActions {
    clearTumourGroup: TumourGroupActions.ITumourGroupClearActionCreator;
    loadTumourGroup: TumourGroupActions.ITumourGroupLoadByIdActionCreator;

    saveTumourGroup: TumourGroupActions.ITumourGroupSaveActionCreator;
    createTumourGroup: TumourGroupActions.ITumourGroupCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type TumourGroupPageProps = ITumourGroupPageProps & ITumourGroupPageActions;

const reduxFormName: string = "reduxForms.tumourGroup";

class TumourGroupPage extends React.PureComponent<TumourGroupPageProps, any> {

    constructor(props: TumourGroupPageProps) {
        super(props);

        this.clearTumourGroup = this.clearTumourGroup.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTumourGroup,
            tumourGroupId,
            createTumourGroup
        } = this.props;

        if (tumourGroupId) {
            loadTumourGroup(tumourGroupId);
        } else if (!tumourGroupId) {
            createTumourGroup();
        }
    }

    componentWillReceiveProps(nextProps: TumourGroupPageProps) {
    }

    componentDidUpdate(prevProps: TumourGroupPageProps, prevState) {
        const {
            tumourGroupId,
            tumourGroup,
            form,
            navigate,
            loadTumourGroup,
            loadingTumourGroup,
            loadTumourGroupSuccess,
            createTumourGroup,
            creatingTumourGroup,
            createTumourGroupSuccess,
            savingTumourGroup,
            saveTumourGroupSuccess,
            validationFailures
        } = this.props;

        if (tumourGroupId && prevProps.tumourGroupId != tumourGroupId) {
            loadTumourGroup(tumourGroupId);
        }
        else if (!tumourGroupId && prevProps.tumourGroupId) {
            createTumourGroup();
        }

        if (!loadingTumourGroup && prevProps.loadingTumourGroup) {
            if (loadTumourGroupSuccess) {
                this.loadForm();
            }
        }

        if (!savingTumourGroup && prevProps.savingTumourGroup) {
            if (saveTumourGroupSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/trial/tumourgroups")
                } else if (!form.saveAndReturn && tumourGroupId && tumourGroupId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !tumourGroupId && tumourGroup && tumourGroup.id > 0) {
                    navigate("/settings/trial/tumourgroups/" + tumourGroup.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingTumourGroup && prevProps.creatingTumourGroup) {
            if (createTumourGroupSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(nextProps: TumourGroupPageProps) {
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearTumourGroup();
        loadForm(reduxFormName, initialTumourGroupState);
        resetForm(reduxFormName);
    }

    clearTumourGroup() {
        this.props.clearTumourGroup();
    }

    showTumourGroup(): boolean {
        const {
            loadingTumourGroup,
            loadTumourGroupSuccess
        } = this.props

        if (!loadingTumourGroup && loadTumourGroupSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTumourGroup
        } = this.props;

        return <TrialLookupsLayout loading={loadingTumourGroup} permission={Dtos.Permission.TumorGroupsView}>
            {this.renderContent()}
        </TrialLookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingTumourGroup,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TumorGroupsUpdate, Dtos.Permission.TumorGroupsCreate);
        const formDisabled: boolean = !hasPermission || savingTumourGroup || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Tumour Group</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "tumourGroup", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.TumourGroup) {
        const {
            saveTumourGroup
        } = this.props;

        if (data) {
            let changes: Dtos.TumourGroup = {} as Dtos.TumourGroup;
            saveTumourGroup(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.TumourGroup) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/trial/tumourgroups");
    }

    loadForm() {
        const {
            loadForm,
            tumourGroup,
        } = this.props

        let extraData: Dtos.TumourGroup = {} as Dtos.TumourGroup;

        loadForm(reduxFormName, Object.assign({ ...tumourGroup }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: TumourGroupPageProps): ITumourGroupPageProps => {

    let tumourGroup: Dtos.TumourGroup | undefined = !(state.tumourGroups.formData instanceof Array) ? state.tumourGroups.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        tumourGroupId: ownProps.match && ownProps.match.params.tumourGroupId && ownProps.match.params.tumourGroupId.toString() != "create" ? ownProps.match.params.tumourGroupId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        tumourGroup: tumourGroup!,

        loadingTumourGroup: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Pending,
        loadTumourGroupSuccess: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Success,
        loadTumourGroupFailure: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Failure,

        savingTumourGroup: state.tumourGroups.saveState && state.tumourGroups.saveState.status == RequestState.Pending,
        saveTumourGroupSuccess: state.tumourGroups.saveState && state.tumourGroups.saveState.status == RequestState.Success,
        saveTumourGroupFailure: state.tumourGroups.saveState && state.tumourGroups.saveState.status == RequestState.Failure,

        creatingTumourGroup: state.tumourGroups.createState && state.tumourGroups.createState.status == RequestState.Pending,
        createTumourGroupSuccess: state.tumourGroups.createState && state.tumourGroups.createState.status == RequestState.Success,
        createTumourGroupFailure: state.tumourGroups.createState && state.tumourGroups.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.tumourGroup,
        formState: state.tumourGroups.formState,
        formProperties: state.tumourGroups.formProperties,

        reduxFormState: state.reduxForms.formState.tumourGroup,
        validationFailures: tumourGroup ?
            state.tumourGroups.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): ITumourGroupPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTumourGroup: bindActionCreators(TumourGroupActions.LoadTumourGroupById, dispatch),
        clearTumourGroup: bindActionCreators(TumourGroupActions.Clear, dispatch),

        saveTumourGroup: bindActionCreators(TumourGroupActions.SaveTumourGroup, dispatch),
        createTumourGroup: bindActionCreators(TumourGroupActions.CreateTumourGroup, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TumourGroupPage);
